import React, { FC, ChangeEvent, useState, memo } from 'react';
import { useFormikContext } from 'formik';
import Input from '@minecraft.input';
import { FilterData } from '../../../shared/types';
import { Label } from '../../../shared/styles';

const MIN_CHARACTERS_LIMIT = 3;

type Props = FilterData;

const OtherExperience: FC<Props> = ({ name, label }) => {
  const { values, setFieldValue } = useFormikContext();

  const [value, setValue] = useState(values[name] || '');

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const otherExperienceValue = event.target.value;

    setValue(otherExperienceValue);

    if (otherExperienceValue.length >= MIN_CHARACTERS_LIMIT) {
      setFieldValue(name, otherExperienceValue, false);
    } else {
      setFieldValue(name, '', false);
    }
  };

  return (
    <>
      <Label htmlFor="filter-drawer-other-experience">{label}</Label>
      <Input
        id="filter-drawer-other-experience"
        showLimit
        value={value}
        name={name}
        minLength={MIN_CHARACTERS_LIMIT}
        size="small"
        onChange={handleChange}
      />
    </>
  );
};

export default memo(OtherExperience);
